import { useQuery } from '@tanstack/react-query'
import type { OrganizationOutput } from '@/types/organization'
import { getOrganization } from '../services/organization'

// ── Query keys ────────────────────────────────────────────────────────────────

export const organizationKeys = {
	all: ['organization'] as const,
	admin: ['organization', 'admin'] as const,
}

// ── GET /organization ─────────────────────────────────────────────────────────

export function useOrganization(showHidden = false) {
	return useQuery<OrganizationOutput>({
		queryKey: showHidden ? organizationKeys.admin : organizationKeys.all,
		queryFn: () => getOrganization(showHidden),
		staleTime: 5 * 60 * 1000,
	})
}
